module.exports = __webpack_public_path__ + "static/media/devices-us.c8878a78.png";